<template>
    <v-data-table
        dense
        :headers="headers"
        :items="value"
        :loading="loading"
        hide-default-footer
        disable-pagination
        disable-sort
    >
        <template v-slot:[`item.name`]="{item}">
            <v-btn icon color="primary" @click="handleRowClick(item)" v-if="hasPermission(perm.supplier_contact.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
                {{item.name}}
        </template>
    </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';
import permissions from './../../data/permissions';
export default {
    name: "SupplierContactList",
    props: {
        value: Array
    },
    data() {
        return {
            loading: false,
            headers: [
                { text: "Name", value: "name" },
                { text: "Phone", value: "phone" },
                { text: "Position", value: "position"}
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods:{
        handleRowClick(item) {
            this.$router.push({ name: "SupplierContactDisplay", params: { id: item.id }})
        }
    }
}
</script>

<style>

</style>